module.exports = __webpack_public_path__ + "img/India.fd584fa5.svg";